import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

import PerfectScrollbarComponent from 'react-perfect-scrollbar'

const PerfectScrollbar = styled(PerfectScrollbarComponent)(({ theme }) => ({
  padding: theme.spacing(5)
}))

import { useTranslation } from 'src/utils/i18n'

// ** Icon Imports
import Icon from 'src/@core/components/icon'
import Image from 'next/image'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import ExtremeUpgradeModal from 'src/@core/components/modal/extreme-upgrade'
import { useExtremeFeatureAccessGate } from 'src/hooks/useExtremeFeatureAccessGate'

const ChatCall = props => {
  const { t } = useTranslation('common')

  const { advanced, fetchLoading } = props
  const store = useSelector(state => state.Common)
  const basicNotOver = [null, ''].includes(store.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
  const advancedNotOver = [null, ''].includes(store.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
  // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
  const { gatePending, showUpgradeModal } = useExtremeFeatureAccessGate(advanced)
  const [justVerified, setJustVerified] = useState(false) // 是否为刚完成验证

  return (
    <div className='relative'>
      {
        !fetchLoading && !gatePending &&
        <>
          {
            (!basicNotOver && !advancedNotOver && !justVerified) ?
              <>
                {/* 高级服务开通提示 */}
                {showUpgradeModal && <ExtremeUpgradeModal open />}
              </>
              :
              <>
                {/* 增值服务 iCloud验证流程 */}
              </>
          }

        </>
      }
      <div
        ref={props.dom}
        className={`bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-94px)] Bxls:Headers5:h-[calc(var(--vh2)*100-149px)] Header5:big:h-[calc(var(--vh2)*100-214px)] bigs:h-[calc(var(--vh2)*100-274px)] pb-[20px] flex flex-col ${advanced ? 'overflow-auto' : 'overflow-hidden'}`}
      >
        <table className={`border-separate border-spacing-x-[15px] border-spacing-y-[10px] w-full ${!advanced ? 'blur-[16px] select-none' : ''}`}>
          <tr className='sticky top-0 bg-[#FFF]'>
            <th className='pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap'>{t('DATE')}</th>
            <th className='pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap'>{t('DIRECTION')}</th>
            <th className='pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap'>{t('GROUP NAME')}</th>
            <th className='pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap'>{t('DISPLAY NAME')}</th>
            <th className='pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap'>{t('IDENTIFIER')}</th>
          </tr>
          {props.data.map((row, i) => (
            <tr key={i}>
              <td className='text-[14px] text-[#000] text-nowrap'>{row.date}</td>
              <td className='text-[14px] text-[#000] text-nowrap flex items-center'>
                <Image
                  className='mr-[5px]'
                  src={row.isFromMe ? 'images/calls/outgoing.svg' : 'images/calls/incoming.svg'}
                  width={24}
                  height={24}
                  alt={row.originated === 0 ? (row.duration === 0 ? 'missed' : 'incoming') : 'outgoing'}
                />
              </td>
              <td className='text-[14px] text-[#000] text-nowrap'>{row.groupName}</td>
              <td className='text-[14px] text-[#000] text-nowrap'>{row.displayName}</td>
              <td className='text-[14px] text-[#000] text-nowrap'>{row.identifier}</td>
            </tr>
          ))}
        </table>
        {advanced && !fetchLoading && !gatePending && props.data.length == 0 &&
          <div className='text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
    </div>
  )
}

export default ChatCall
